module.exports = __webpack_public_path__ + "static/img/header_600.2566c74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hrdonates/header_600.png
// module id = HVhL
// module chunks = 0